<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card v-if="currentMode === 'form'">
      <v-card-title>
        <span class="headline">
          <span> Test template </span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="testInput"
                required
                :label="templateType === 2 ? 'Email *' : 'Phone Number *'"
                :error="!(testInput && testInput.length) && isFormDirty"
              />
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="_close"> Cancel </v-btn>
        <v-btn color="primary" text @click="_submit"> Send </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="currentMode === 'success'">
      <div class="successWrapper">
        <div class="iconWrapper">
          <img src="../../../assets/images/general-images/check-mark.png" alt="submitted" />
        </div>
        <div class="successText">
          {{ templateType === 3 ? "Call initiated " : "Message sent " }}
          successfully
        </div>
        <div class="closeBtnWrapper">
          <v-btn class="dismissBtn" text @click="_close"> Dismiss </v-btn>
        </div>
      </div>
    </v-card>
    <v-card v-if="currentMode === 'loader'">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
import { ApiCalls } from "../../../api-calls";
import UserHelper from "../../../utils/user-helper";
import Api from "../../../modules/shared-module/api";

Vue.directive("mask", VueMaskDirective);

export default {
  name: "TemplateTester",
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    templateType: {
      type: Number,
      default: 1, // 1 = SMS, 2 = Email
    },
    templateData: {
      type: Object,
      default: null, // 1 = SMS, 2 = Email
    },
  },
  data: () => ({
    testInput: "",
    snackbar: false,
    notification: "Unknown",
    currentMode: "form", // all values: ['form', 'loader', 'success']
    isFormDirty: false
  }),

  watch: {
    isVisible(val) {
      if (!val) {
        this.testInput = "";
        this.currentMode = "form";
      } else {
        console.log("this.templateData", this.templateData);
      }
    },
  },

  created() {},

  methods: {
    _submit() {
      if (this.testInput && this.testInput.length) {
        this._sendMessage();
      } else {
        this.notification = `Enter a valid ${this.templateType === 2 ? "email" : "phone number"}`;
        this.snackbar = true;
      }
    },

    _prependAreaCodeIfRequired(phoneNumber) {
      if (phoneNumber && phoneNumber.length) {
        if (phoneNumber.indexOf("+1") === 0) {
          return phoneNumber;
        } else {
          return `+1${phoneNumber}`;
        }
      }
      return null;
    },
    _getPracticeIdFromStore() {
      let practiceId = null;
      if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
        practiceId = this.$store.state.posActivePractice.value;
      }
      return practiceId;
    },
    async _sendMessage() {
      try {
        this.currentMode = "loader";
        switch (this.templateType) {
          case 1: {
            // SMS
            const activePracticeId = this._getPracticeIdFromStore();
            const phoneNumbers = `${this._prependAreaCodeIfRequired(this.testInput)};`;
            const messagePayload = {
              //ToPhoneNumbers: phoneNumbers,
              ToNumber: phoneNumbers,
              Message: this.templateData.body,
              CampaignName: "",
              MediaURL: "",
              TwilioSID: "ACfffb0bc0e31d44d40c9ecf9e6647c69d",
              PracticeID: activePracticeId,
              Signiture: "",
            };
            await ApiCalls.sendMessage(messagePayload);
            break;
          }
          case 2: {
            // Email
            const messagePayload = {
              Content: this.templateData.body,
              ToEmails: `${this.testInput};`,
              Signiture: "",
              FromEmail: this.templateData.fromAddress,
              Subject: this.templateData.emailSubject,
            };
            await ApiCalls.sendEmail(messagePayload);
            break;
          }
          case 3: {
            // IVR
            const activeClinic = UserHelper.getActiveClinic();
            const phoneNumber = this._prependAreaCodeIfRequired(this.testInput);
            const messagePayload = {
              FlowID: this.templateData.flowId,
              //ToPhoneNumbers: `${phoneNumber};`,
              ToNumber: phoneNumbers,
              FlowPhoneNumber: "+17088872527",
              FlowParameters: [
                {
                  Parameter: "firstname",
                  ParameterValue: "John",
                },
                {
                  Parameter: "lastname",
                  ParameterValue: "Doe",
                },
                {
                  Parameter: "practicename",
                  ParameterValue: activeClinic.name,
                },
                {
                  Parameter: "doctor",
                  ParameterValue: "Dr. Smith",
                },
                {
                  Parameter: "ApptDate",
                  ParameterValue: "June 11, 2022",
                },
                {
                  Parameter: "message",
                  ParameterValue: this.templateData.body,
                },
              ],
            };
            await Api.ivr.private.initiateBulkCall(messagePayload);
            break;
          }
          default:
        }
        this.currentMode = "success";
      } catch (error) {
        this.currentMode = "form";
        this.notification = `Unable to send ${this.templateType === 2 ? "email" : "sms"}`;
        this.snackbar = true;
        console.log("error", error);
      }
    },
    _close() {
      this.$emit("on-dismiss");
      this.testEmail = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.successWrapper {
  padding: 35px 0;
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .iconWrapper {
    img {
      width: 80px;
    }
  }
  .successText {
    font-size: 1.3rem;
    margin-top: 15px;
  }
  .closeBtnWrapper {
    .dismissBtn {
      margin: 25px 0 5px 0;
      background-color: red;
      color: white;
    }
  }
}
.progressWrapper {
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    margin-left: 0rem !important;
  }
  flex-direction: column;
  img {
    margin-bottom: 25px;
  }
}
</style>
